import { Typography } from "@material-ui/core";
import styled from "styled-components";

export const StyledTitle = styled(Typography)`
  color: ${props => props.theme.palette.secondary.main};
  margin-bottom: ${props => props.theme.spacing(1)}px;
`;

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 450px) 1fr;
  align-items: center;
  gap: ${props => props.theme.spacing(1, 3)};
  margin-bottom: ${props => props.theme.spacing(5)}px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(auto, 450px) 1fr;
  }
`;

export const StyledPositionsWrapper = styled.div`
  display: grid;
  gap: ${props => props.theme.spacing(0.75, 0)};

  @media (max-width: 1000px) {
    grid-area: 1/1/1/3;
  }

  & > div {
    padding: ${props => props.theme.spacing(0.25)}px;
    position: relative;
  }
`;

export const StyledDate = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${props => props.theme.typography.h5.fontSize}px;
  padding-bottom: ${props => props.theme.spacing(0.75)}px;
`;

export const StyledError = styled.div`
  color: ${props => props.theme.colors.red};
  font-style: italic;
  padding-bottom: ${props => props.theme.spacing(1)}px;
  align-self: flex-end;
  min-height: 30px;

  @media (max-width: 1000px) {
    & > * {
      font-size: 12px;
    }
  }

  ${props => props.theme.breakpoints.down("xs")} {
    padding: 0;
    min-height: 0;
    position: relative;
    & > * {
      font-size: 12px;
      position: absolute;
      left: 0;
      top: -8px;
    }
  }
`;

export const StyledNewPositionWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 193px) minmax(auto, 193px) auto auto 1fr;
  align-items: flex-end;
  gap: ${props => props.theme.spacing(0, 2)};
  margin-top: ${props => props.theme.spacing(1)}px;
  grid-area: 2/1/2/3;

  > div {
    &:first-child {
      grid-area: 1/1/1/3;
    }

    &:nth-child(2) {
      margin-top: ${props => props.theme.spacing(1)}px;
      grid-area: 2/1/2/3;
    }

    &:nth-child(3) {
      grid-area: 2/3/2/3;
    }

    &:nth-child(4) {
      grid-area: 1/4/1/4;
    }

    &:nth-child(5) {
      grid-area: 2/4/2/4;
    }
  }

  @media (max-width: 1000px) {
    grid-template-columns: minmax(auto, 193px) minmax(auto, 193px) auto auto 1fr;
  }

  ${props => props.theme.breakpoints.down("xs")} {
    grid-template-columns: 1fr auto;
    gap: ${props => props.theme.spacing(1, 2)};

    div:nth-of-type(1) {
      grid-area: 1/1;
    }
    div:nth-of-type(2) {
      grid-area: 3/1;
    }
    div:nth-of-type(3) {
      grid-area: 3/2;
    }
    div:nth-of-type(4) {
      grid-area: 2/1;
    }
    div:nth-of-type(5) {
      grid-area: 4/1;
    }
  }
`;

export const StyledTrashIcon = styled.div`
  position: absolute;
  right: 0;
  bottom: 3px;

  svg {
    height: 20px;
  }
`;
